import React from "react";
import { Circle } from "@speedoc/design-assets/build/icons/index.js";
import { Step } from "@speedoc/design-assets";
import useAppDownloadLink from "../../hooks/useAppDownloadLink";
import { useMediaQuery } from "react-responsive";
import { GlobalStore } from "../../stores/global";

export default ({
  list,
  buttonText,
  linkText,
  linkTextMobile,
  buttonIsPhoneNumber,
  numbered = false,
  description,
  isShowButtonDownload,
  linkUrl
}) => {
  const {
    config,
    currentCountry: { phoneNumberLink }
  } = GlobalStore.useState(c => c);

  const downloadLink = useAppDownloadLink();
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const { appStoreLink, playStoreLink } = config.storeLinks;

  return (
    <div className={`featureList ${numbered ? "" : "marginSm"}`}>
      {list.map((content, index) => {
        if (numbered) {
          return (
            <div className="feature" key={index}>
              <Step
                stepId={index + 1}
                stepTitle={content.text || content.title || content.content}
                stepSubtitle={content.subtitle}
                isActive={false}
                className={`sm ${content.subtitle ? "withSubtitle" : ""} disabled`}
              />
            </div>
          );
        }

        return (
          <div className="feature" key={index}>
            <Circle />
          </div>
        );
      })}
      {isShowButtonDownload && (
        <div className="buttons">
          <div className="buttonApp">
            <a href={appStoreLink} className="">
              <img src="//public.speedoc.com/strapi/btn_appleappstore_7d166925e8.svg" alt="" />
            </a>
          </div>
          <div className="buttonApp">
            <a href={playStoreLink} className="">
              <img src="//public.speedoc.com/strapi/btn_googleplay_ed1b5b2c10.svg" alt="" />
            </a>
          </div>
        </div>
      )}
      {description && <span className="description">{description}</span>}
      <div className="button">
        <a
          href={linkUrl ? linkUrl : buttonIsPhoneNumber && !isMobile ? phoneNumberLink : downloadLink}
          className="linkSecondary sm">
          <span>{isMobile ? linkTextMobile || buttonText : buttonText || linkText}</span>
        </a>
      </div>
    </div>
  );
};
